const { Module } = require('../prisma/types');

const TEXT = 'TEXT';
const TEXTAREA = 'TEXTAREA';
const NUMBER = 'NUMBER';
const EMAIL = 'EMAIL';

const FIELD = 'FIELD';
const RADIO = 'RADIO';
const CHECKBOX = 'CHECKBOX';
const ZIP = 'ZIP';
const COUNTRY = 'COUNTRY';
const CONTACT = 'CONTACT';
const SENTIMENT = 'SENTIMENT';
const THUMBS = 'THUMBS';
const NPS = 'NPS';
const GRADE = 'GRADE';
const FIND = 'FIND';

const SURVEY = 'SURVEY';
const INTRO = 'INTRO';
const THANK_YOU = 'THANK_YOU';
const DECLINED = 'DECLINED';
const GDPR = 'GDPR';
const COOKIES = 'COOKIES';
const A11Y = 'A11Y';

const SUB_TYPES = {
  TEXTAREA,
  TEXT,
  NUMBER,
  EMAIL,
};

const CONTENT_TYPES = {
  QUESTION: 'QUESTION',
  BLOCK: 'BLOCK',
  PAGE_BREAK: 'PAGE-BREAK',
  TEXT: 'TEXT',
};

const QUESTION_TYPES = {
  FIELD,
  RADIO,
  CHECKBOX,
  ZIP,
  COUNTRY,
  CONTACT,
  SENTIMENT,
  THUMBS,
  NPS,
  FIND,
  GRADE,
};

const PAGES = {
  SURVEY,
  INTRO,
  THANK_YOU,
  DECLINED,
  GDPR,
  COOKIES,
  A11Y,
};

const DEFAULT_OPTIONS = {
  THUMBS: [{ title: '👍', value: 100 }, { title: '👎', value: -100 }],
  SENTIMENT: [
    { title: '😠', value: 1 }, { title: '🙁', value: 2 }, { title: '😐', value: 3 },
    { title: '🙂', value: 4 }, { title: '😀', value: 5 },
  ],
  NPS: [
    { title: '0', value: -100 },
    { title: '1', value: -100 },
    { title: '2', value: -100 },
    { title: '3', value: -100 },
    { title: '4', value: -100 },
    { title: '5', value: -100 },
    { title: '6', value: -100 },
    { title: '7', value: 0 },
    { title: '8', value: 0 },
    { title: '9', value: 100 },
    { title: '10', value: 100 },
  ],
  GRADE: [
    { title: '1', value: 1 },
    { title: '2', value: 2 },
    { title: '3', value: 3 },
    { title: '4', value: 4 },
    { title: '5', value: 5 },
  ],
};

const MODULE_FROM_PATH = {
  'ux-surveys': Module.UxSurveys,
  'cx-surveys': Module.CxSurveys,
};

const MODULE_PATH = {
  [Module.UxSurveys]: 'ux-surveys',
  [Module.CxSurveys]: 'cx-surveys',
};

module.exports = {
  PAGES,
  CONTENT_TYPES,
  QUESTION_TYPES,
  SUB_TYPES,
  DEFAULT_OPTIONS,
  MODULE_FROM_PATH,
  MODULE_PATH,
};
